import React from 'react';
import styles from './W_ProgressBilling.module.css';
import M_ProgressBarPlant from '@/components/M_Molecules/M_ProgressBarPlant/M_ProgressBarPlant';
import cn from 'classnames';
import { formatPrice } from '@/utils/formatters';
import C_CapsuleUserAvatars from '@/components/C_Collections/C_CapsuleUserAvatars/C_CapsuleUserAvatars';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_ProgressBillingProps {
  progress: number;
  totalDonations: number;
  cost: number;
  name?: string;
  donorsCount: number;
  showDonorsCount?: boolean;
  donorsAvatars?: string[];
}

export default function W_ProgressBilling({
  progress,
  totalDonations,
  cost,
  name,
  donorsCount,
  showDonorsCount = false,
  donorsAvatars = [],
}: W_ProgressBillingProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  return (
    <div className={styles.wrapper}>
      <M_ProgressBarPlant progress={progress} />
      <div className={styles.content}>
        <div className={styles.donors_wrapper}>
          {donorsAvatars.length > 0 && (
            <C_CapsuleUserAvatars avatars={donorsAvatars} />
          )}
          <span className={cn(styles.text, 'text-p-7')}>
            {showDonorsCount
              ? `${donorsCount} ${t('payment.progressBilling.people')}`
              : name}
          </span>
        </div>
        <span className={cn(styles.text, 'text-p-7')}>
          {t('payment.progressBilling.collected')} {formatPrice(totalDonations)}{' '}
          / {formatPrice(cost)}
        </span>
      </div>
    </div>
  );
}
